import type { ReactNode } from 'react'
import { useAuth } from '../../context/AuthContext'

type PermissionGateProps = {
  permission: string
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Renders children only when the logged-in user may use the given permission.
 * For `doctors-*`, this also requires “Allowed to review doctor profiles”.
 */
export function PermissionGate({ permission, children, fallback = null }: PermissionGateProps) {
  const { can } = useAuth()

  if (!can(permission)) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
